"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle handheld/desktop value replacement for button elements
 *
 * @namespace
 * @memberOf txGs1Base.forms
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.forms.buttons = {
    /**
     * Initialize
     */
    initialize: function () {
        var $buttons = $('button[data-value-handheld], a.btn[data-value-handheld]');
        /**
         * Register enter and exit functions for handheld breakpoint
         *
         * @memberOf txGs1Base.respond
         * @type {*}
         */
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['handheld', 'tablet_portrait', 'tablet_landscape'],
            enter: function () {
                $buttons.find('.btntxt').text(function (e) {
                    return $(this).parent().data('valueHandheld');
                });
            },
            exit: function () {
                $buttons.find('.btntxt').text(function (e) {
                    return $(this).parent().attr('value');
                });
            }
        });
    }
};
exports.default = {};
